<template>
  <div
    id="tgs-news"
    class="overflow-hidden max-w-md relative"
    style="max-width: 400px"
  >
      <v-row class="ma-0 w-full white mb-3 white">
        <v-speed-dial
          v-model="fab"
          v-if="$route.path.includes('account')"
          right
          class="absolute mt-1 mr-n3"
          direction="left"
          transition="slide-x-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" text fab small>
              <v-icon color="red darken-1" v-if="fab">mdi-close</v-icon>
              <v-icon v-else color="grey darken-1">mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                @click="$store.dispatch('news/delete', { id: info._id })"
                dark
                small
                color="red"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("delets_item") }}</span>
          </v-tooltip>
        </v-speed-dial>
        <v-col cols="3">
          <!-- :src="$connection + '/images/tgs.jpg'" -->
          <v-img
            contain
            class="overflow-hidden"
            width="100"
            height="100"
            :src="$connection + info.photoURL"
            v-if="info.photoURL" 
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0 grey lighten-2"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-avatar v-else size="80 " rounded color="grey lighten-3">
            <div class="text-h6" v-if="info.info.length > 0">
              {{ info.info.slice(0, 2).toUpperCase() }}
            </div>
            <v-icon v-else>mdi-dots-horizontal</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="9">
          <div
            class="text-subtitle-1 font-weight-bold grey--text text--darken-3 ellipsis-1"
          >
            {{ info.title }}
          </div>
          <div class="text-body-2 ellipsis-3">{{ info.text }}</div>
          <div class="d-flex text-caption primary--text mt-2 ellipsis-1">
            <div class>{{ $moment(info.created_at).format("DD.MM.YYYY") }}</div>
            <div class="grey-dot mx-3 grey align-self-center"></div>
            <div class>{{ $moment(info.created_at).format("HH:mm") }}</div>
            <div class="grey-dot mx-3 grey align-self-center"></div>
            <div class="ellipsis-1">
              {{ info.created_by ? info.created_by.name : user.fullname }}
            </div>
          </div>
          <div class="text-caption font-weight-medium">{{ info.info }}</div>
        </v-col>
      </v-row>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["info"],
  data() {
    return {
      fab: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
